import styled from "styled-components";
import colors from "../../../../../../../../../styles/colorPalette";

export const CheckboxContainer = styled.div`
  display: flex;
  margin-top: 2px;
  margin-left: 5px;
  overflow: visible;
`;

export const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 3px;
`;

export const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  box-shadow: orange 0px 22px 70px 4px;
`;

export const StyledCheckbox = styled.div`
  display: flex;
  width: 16px;
  height: 16px;
  background: ${(props) => (props.checked ? colors.orange1 : "transparent")};
  border-radius: 3px;
  transition: all 0.4s;
  box-shadow: orange 0px 22px 70px 4px;
  border: ${(props) => (props.checked ? "none" : `1px solid ${colors.gray4}`)};
  box-sizing: border-box;
  ${HiddenCheckbox}:focus + & {
    box-shadow: ${(props) => (props.checked ? `${colors.orange1} 0px 3px 8px` : "rgba(0, 0, 0, 0.24) 0px 3px 8px")};
  }

  ${Icon} {
    visibility: ${(props) => (props.checked ? "visible" : "hidden")};
  }
`;
